/*
    This file is used to store often-changed configs used by codeowned parts of RSDK.
    You are free to make changes in here, just be careful of course!
*/

/* Used in modules/Network/axios/getStatsdTagForUrl to prevent unbounded url tags */
export const STATSD_URL_TAG_MAP_ARRAY: Array<{
  regex: RegExp;
  tag: string;
}> = [
  // MORE SPECIFIC REGEXES MUST GO FIRST, FIRST MATCH WINS
  {
    regex: /https:\/\/api\.lever\.co\/v0\/postings\/rover\?group=team&mode=json/,
    tag: 'https://api.lever.co/v0/postings/rover?group=team&mode=json',
  },
  {
    regex: /\/frontend\/homepage-rebooking-profiles\//,
    tag: '/frontend/homepage-rebooking-profiles/',
  },
  {
    regex: /\/frontend\/current-user\//,
    tag: '/frontend/current-user/',
  },
  {
    regex: /\/frontend\/experiments\//,
    tag: '/frontend/experiments/',
  },
  {
    regex: /\/search-optimized\//,
    tag: '/search-optimized/',
  },
  {
    regex: /\/people\/[a-zA-Z0-9]+\/home\//,
    tag: '/people/:personOpk/home/',
  },
  {
    regex: /\/goodpup-reviews\//,
    tag: '/goodpup-reviews/',
  },
  {
    regex: /\/cities-and-neighborhoods\//,
    tag: '/cities-and-neighborhoods/',
  },
  {
    regex: /\/country-configuration\/current\//,
    tag: '/country-configuration/current/',
  },
  {
    regex: /\/country-configuration\/navigation\//,
    tag: '/country-configuration/navigation/',
  },
  {
    regex: /\/country-configuration\//,
    tag: '/country-configuration/',
  },
  {
    regex: /\/frontend\/country-footer-links\//,
    tag: '/country-footer-links/',
  },
  {
    regex: /\/frontend\/country-region-links\//,
    tag: '/frontend/country-region-links/',
  },
  {
    regex: /\/frontend\/events\//,
    tag: '/frontend/events/',
  },
  {
    regex: /\/frontend\/configuration\//,
    tag: '/frontend/configuration/',
  },
  {
    regex: /\/announcements\/global\//,
    tag: '/announcements/global/',
  },
  {
    regex: /\/bright-horizons\/global-banner\//,
    tag: '/bright-horizons/global-banner/',
  },
  {
    regex: /\/frontend\/href-langs\//,
    tag: '/frontend/href-langs/',
  },
  {
    regex: /\/utilities\/location-autocomplete\//,
    tag: '/utilities/location-autocomplete/',
  },
  {
    regex: /\/utilities\/location-geocode\//,
    tag: '/utilities/location-geocode/',
  },
  {
    regex: /\/announcements\/notifications\//,
    tag: '/announcements/notifications/',
  },
  {
    regex: /\/payment-intents\//,
    tag: '/payment-intents/',
  },
  {
    regex: /\/frontend\/user-person-summary\//,
    tag: '/frontend/user-person-summary/',
  },
  {
    regex: /\/phones\//,
    tag: '/phones/',
  },
  {
    regex: /\/pets\//,
    tag: '/pets/',
  },
  {
    regex: /\/my-pets\//,
    tag: '/my-pets/',
  },
  {
    regex: /\/seo-location\/.+\/reviews\//,
    tag: '/seo-location/:seoLocationSlug/reviews/',
  },
  {
    regex: /\/seo-location\//,
    tag: '/seo-location/',
  },
  {
    regex: /\/reviews-snippet\//,
    tag: '/reviews-snippet/:city/:region/:serviceType',
  },
  {
    regex: /\/frontend\/service-types\//,
    tag: '/frontend/service-types/',
  },
  {
    regex: /\/frontend\/top-cities\//,
    tag: '/frontend/top-cities/',
  },
  {
    regex: /\/frontend\/footer\//,
    tag: '/frontend/footer/',
  },
  {
    regex: /\/frontend\/homepage-configuration\//,
    tag: '/frontend/homepage-configuration/',
  },
  {
    regex: /\/frontend\/homepage-service-types\//,
    tag: '/frontend/homepage-service-types/',
  },
  {
    regex: /\/frontend\/service-links\//,
    tag: '/frontend/service-links/',
  },
  {
    regex: /\/frontend\/internal-linking\//,
    tag: '/frontend/internal-linking/',
  },
  {
    regex: /\/people\/full-sitter-profile\//,
    tag: '/people/full-sitter-profile/',
  },
  {
    regex: /\/people\/[a-zA-Z0-9]+\/public-calendar\//,
    tag: '/people/:opk/public-calendar/',
  },
  {
    regex: /\/people\/[a-zA-Z0-9]+\/reviews\//,
    tag: '/people/:opk/reviews/',
  },
  {
    regex: /\/people\/[a-zA-Z0-9]+\/stay-media\//,
    tag: '/people/:opk/stay-media/',
  },
  {
    regex: /\/people\/[a-zA-Z0-9]+\/images\//,
    tag: '/people/:opk/images/',
  },
  {
    regex: /\/provider-profile\/hub\//,
    tag: '/provider-profile/hub/',
  },
  {
    regex: /\/provider-profile\/cat-profile\//,
    tag: '/provider-profile/cat-profile/',
  },
  {
    regex: /\/provider-profile\/trainer-sitter-sign-up\/[a-zA-Z0-9-]+\/cat-profile\//,
    tag: '/provider-profile/trainer-sitter-sing-up/:serviceSlug/cat-profile/',
  },
  {
    regex: /\/frontend\/service-landing\//,
    tag: '/frontend/service-landing/',
  },
  {
    regex: /\/facilities\/[a-zA-Z0-9]+\/contact\//,
    tag: '/facilities/:opk/contact/',
  },
  {
    regex: /\/facilities\/vet-list\//,
    tag: '/facilities/vet-list/',
  },
  {
    regex: /\/facilities\/[a-zA-Z0-9]+\//,
    tag: '/facilities/:opk/',
  },
  {
    regex: /\/facilities\/user-context\//,
    tag: '/facilities/user-context/',
  },
  {
    regex: /\/facility-booking\/[a-zA-Z0-9]+\//,
    tag: '/facility-booking/:opk/',
  },
  {
    regex: /\/grooming\/search\//,
    tag: '/grooming/search/',
  },
  {
    regex: /\/reviews\/facility\/[a-zA-Z0-9]+\//,
    tag: '/reviews/facility/:opk/',
  },
  {
    regex: /\/reviews\/trainer-testimonial-requests\/[a-zA-Z0-9]+\//,
    tag: '/reviews/trainer-testimonial-requests/:token/',
  },
  {
    regex: /\/reviews\/trainer-testimonial-requests\//,
    tag: '/reviews/trainer-testimonial-requests/',
  },
  {
    regex: /\/training\/members\/[a-zA-Z-]+\/services\/[a-zA-Z-]+\/bundle-offerings\//,
    tag: '/training/members/:providerSlug/services/:serviceSlug/bundle-offerings/',
  },
  {
    regex: /\/training\/members\/[^/]+\//,
    tag: '/training/members/:slug/',
  },
  {
    regex: /\/training\/trainer-testimonials\/add\//,
    tag: '/training/trainer-testimonials/add/',
  },
  {
    regex: /\/training\/methodology-requirement\//,
    tag: '/training/methodology-requirement/',
  },
  {
    regex: /\/training\/certification-requirement\//,
    tag: '/training/certification-requirement/',
  },
  {
    regex: /\/training\/trainer-profile\/behaviors\//,
    tag: '/training/trainer-profile/behaviors/',
  },
  {
    regex: /\/training\/behavior-skill-options\//,
    tag: '/training/behavior-skill-options',
  },
  {
    regex: /\/training\/trainer-profile\/skills\//,
    tag: '/training/trainer-profile/skills/',
  },
  {
    regex: /\/training\/trainer-profile\/behaviors-custom\//,
    tag: '/training/trainer-profile/behaviors-custom/',
  },
  {
    regex: /\/training\/trainer-profile\/skills-custom\//,
    tag: '/training/trainer-profile/skills-custom/',
  },
  {
    regex: /\/training\/trainer-profile\/details\//,
    tag: '/training/trainer-profile/details/',
  },
  {
    regex: /\/training\/search-results\//,
    tag: '/training/search-results/',
  },
  {
    regex: /\/training\/trainer-profile\/education\//,
    tag: '/training/trainer-profile/education/',
  },
  {
    regex: /\/provider-profile\/person\/[a-zA-Z-]+\//,
    tag: '/provider-profile/person/:service_preferences_slug/',
  },
  {
    regex: /\/training\/certification-interest-confirmation\//,
    tag: '/training/certification-interest-confirmation/',
  },
  {
    regex: /\/conversations\/[a-zA-Z0-9]+\//,
    tag: '/conversations/:conversation_opk/',
  },
  {
    regex: /\/people\/[a-zA-Z0-9]+\/services\/[^/]+\//,
    tag: '/people/:opk/services/:service_slug/',
  },
  {
    regex: /\/training\/session-cancellation-reasons\/(provider|owner)\//,
    tag: '/training/session-cancellation-reasons/:user_type/',
  },
  {
    regex: /\/order\/[a-zA-Z0-9]+/,
    tag: '/order/:opk/',
  },
  {
    regex: /\/checkout\/[a-zA-Z0-9]+\/screen\//,
    tag: '/checkout/:opk/screen/',
  },
  {
    regex: /\/checkout\/[a-zA-Z0-9]+\/confirmation-details/,
    tag: '/checkout/:opk/confirmation-details/',
  },
  {
    regex: /\/training\/conversations\/[a-zA-Z0-9]+\/video-link\//,
    tag: '/training/conversations/:conversation_opk/video-link/',
  },
  {
    regex: /\/training\/video-link\/[a-zA-Z0-9-]+\//,
    tag: '/training/video-link/:token/',
  },
  {
    regex: /\/training\/members\/[^/]+\/nearby-trainer-count\//,
    tag: '/training/members/:slug/nearby-trainer-count/',
  },
  {
    regex: /\/lemonade-pet-user-form\//,
    tag: '/lemonade-pet-user-form/',
  },
  {
    regex: /\/referral\/[a-zA-Z0-9]+\/details\//,
    tag: '/referral/:opk/details/',
  },
  {
    regex: /\/blocking-modal\/marketing-opt-in\//,
    tag: '/blocking-modal/marketing-opt-in/',
  },
  {
    regex: /\/bright-horizons\/sitter-profile-banner\//,
    tag: '/bright-horizons/sitter-profile-banner/',
  },
  {
    regex: /\/training\/credential-organizations\//,
    tag: '/training/credential-organizations/',
  },
];

/* Used in modules/Data/Core/MobileFeatureFlag.native
     native flags are checked by passing these lowercase snakecase strings across the isFeatureFlagActive bridge
  */
export const NATIVE_APP_FLAGS = [
  'rollout_rxn_respond_to_review',
  'rollout_sitter_leaves_feedback_m5_pet_feedback',
  'rollout_behavioural_signals',
  'rollout_behavioural_signals_experiment',
  'rollout_sitter_leaves_review_m5',
  'rollout_edit_pet_insurance_field',
  'rollout_negative_pet_feedback_iteration',
  'rollout_known_pets_sitter_feedback',
  'rollout_ios_native_help_center',
  'rollout_android_native_help_center',
  'rollout_report_and_block_subreasons',
  'rollout_provider_embedded_request_editor',
  'rollout_sitter_promotion_m0_entry_points',
  'rollout_home_profile_v2',
  'rollout_artifacts_sharing_sheet_text',
  'rollout_coupon_decoupling',
] as const;

/** Used in modules/Data/Core/FrontendConfiguration
 * human-readable names for the hashes on the frontendConfiguration.flags API response
 */
export const FRONTEND_CONFIGURATION_FLAGS = {
  CAT_REVIEWS_IN_SEARCH_EXPERIMENT: '0dbadb3de3c4c09e01f86be00d8a409e9c7cd438',
  DEVICE_CURRENT_LOCATION_EXPERIMENT: '0367fc4fe5952478f3bd3c719a6c7e9ee8a079cd',
  EXPERIMENT_SIMPLIFIED_HOMEPAGE_SEARCH_FORM: '53b0d6d7eb1d4183e1eae2d3a4cfa06327b6da7f',
  KILLSWITCH_PET_INSURANCE_INTEGRATION: '5cf50e42f867f21211db5cd7c2e9f24025892fc1',
  QUICK_FACTS_EXPERIMENT: '6084a8f35600ecf3a7c8ecbba3e9cf061fcebc0a',
  REPEAT_SEARCH_EXPERIMENT_20180620_VARIANT: '6b74ac8a0fb97f8f8e50321354750a4afabb4e8a',
  ROLLOUT_EDIT_PET_INSURANCE_FIELD: '27e526f3d12cc45f619ebc01c66697fc96046f5a',
  ROLLOUT_INPUT_DEPENDENT_PERFORMANCE: 'e6f88f0aef4bba4a153f072a86bfa039e2b5659d',
  ROLLOUT_INTERNAL_LINKING: '045b9979887329d4a8981b39b5f50475c16f0dbc',
  ROLLOUT_KETCH_COOKIE_CONSENT: 'a45c39ca9259ae0c55d0a159a502938aef891fba',
  ROLLOUT_SIGN_STATIC_MAP: 'da635c28fc4ff68e452c58a1b0607f3e618884f5',
  ROLLOUT_SITTER_INSIGHTS_ALL_CHARTS: '8a1259985afbbcfb28ca301664779a61a82ea43f',
  ROLLOUT_SITTER_INSIGHTS_PROFILE_VIEWS_CHART: 'b5f0574d0f254849a37a1be5400cbec896c46ea4',
  ROLLOUT_SSR_HOMEPAGE_FULLSTORY: '9ee23cbb87e44c9a299e9fbba6af3792b295e093',
  ROLLOUT_SSR_SEARCH_SESSION_REPLAY: 'a4da5bafaf9e1573b4f37f775ace748359c16a3c',
  ROLLOUT_SSR_SEARCH_FULLSTORY: 'e9a92cd1257d9458e48b0ccafb3bc81b08ee760c',
  ROLLOUT_TRUSTPILOT_BADGE_SCRIPT: '88e2595d30a2fc18be1c79637587d6e5eeb9a5ca',
  ROLLOUT1_SIMPLIFIED_MOBILE_OWNER_SEARCH_FORM: '2814f3822b77980fdf9f5204d8293aaba91f579c',
  ROLLOUT2_SIMPLIFIED_MOBILE_OWNER_SEARCH_FORM: '94b0fadfb590f79dbc6acfcd5fbe9d43eeea9f3d',
  ROLLOUT3_SIMPLIFIED_MOBILE_OWNER_SEARCH_FORM: 'cb95342fb13803a9ccd526ea6bed43f47be36b10',
  ROLLOUT_EMBEDDED_WEB_GOODPUP_LINK: 'd6b95033ecd22de482a5d973fdcb0271cf06d7a1',
  ROLLOUT_CONTACT_PAGE_24H_PICKER: '35d9a21adf184c2d126d11e4da40466ca18b99f0',
  ROLLOUT_SITTER_LEAVES_REVIEW_M5: '7a8ff857c9a9ff310e25d0b569620204eba749d4',
  ROLLOUT_SSR_SITTER_PROFILE_FULLSTORY: 'a8c66b5d47f8c258327bae5d8eeb228edfe1a2f5',
  ROLLOUT_ROVER_PROTECT_CH_2: '3d5a3b311df372cdc9871e8b93ffadde88192e3e',
  KILLSWITCH_ROVER_PROTECT_CH_2_SURVEY: 'f922229a9ca23e9836709427b5fc106c3dae7f16',
  ROLLOUT_DOG_TRAINING_PILOT: 'cd1faa4fe50e12bec2b16cfae00a845f8fd2bdb9',
  ROLLOUT_DOG_TRAINING_PILOT_GLOBAL: '2d62e3c7be03a8d34d120a1a682882501d03296a',
  ROLLOUT_SSR_CITY_SERVICE_FULLSTORY: '390b5b2ce6b59713b4c435bb4a8df29df65aec6b',
  ROLLOUT_AMPLITUDE_ANALYTICS_WEB: 'a3424f5bc57ccdcfe677d32a70d157981d82ab4f',
  ROLLOUT_INSIGHTS_METRICS_ON_PROVIDER_PROFILE: '9e881b7fea39e99192f0f35ee92dd070aa0c23ab',
  ROLLOUT_DIGITAL_PLATFORM_TAX_AGREEMENT: '36c17850ebaeeb9acfb1be33facc7700b7026c96',
  ROLLOUT_ZERO_UNIT_CONVERSATIONS: '83c4a3cb960065055bc975295425583c1222f99b',
  ROLLOUT_SSR_FACILITY_PROFILE_FULLSTORY: '328af2fa44f37b3812db9198e22a7c19c783ea69',
  ROLLOUT_SSR_FACILITY_CONTACT_PAGE_FULLSTORY: '8278f05b7f99978e33897777738a82be6800d169',
  ROLLOUT_SSR_FACILITY_BOOKING_SUMMARY_FULLSTORY: '21a6d863759ce9265a43bfa189423d0e26258268',
  ROLLOUT_RXN_FACILITY_CONTACT_PAGE: 'f102ed80455f42b409ea8deeac904908c543c8a8',
  ROLLOUT_TRAINER_SIGN_UP: 'd062d043aef0b5e808a4711a6fa9983e167e388d',
  ROLLOUT_TRAINER_SIGN_UP_GLOBAL: 'a81f16f9fe7e800f77cb0d1fd3a2c122d4e7ef98',
  ROLLOUT_SSR_TRAINING_SEARCH_FULLSTORY: '1571fcdd3b02e9a23121467ff833c7906a83deeb',
  ROLLOUT_SSR_TRAINING_PUBLIC_TRAINER_PROFILE_FULLSTORY: '1e3211b0f4c942c0cf8213d71ee88f32d32a1803',
  ROLLOUT_SSR_TRAINING_CANCEL_BOOKING_FULLSTORY: 'fff7417cd484f7b49ceb5204f2e6aedc56e119ca',
  ROLLOUT_DOG_TRAINING_ENTRYPOINTS: '7e5fe227c7c4a45be9727143229a8eee75ad73e8',
  ROLLOUT_TRAINING_SUPPRESS_APP_INSTALL_BANNER: '499a01735b53b2a666e350e70743c9270f3883ae',
  ROLLOUT_TRAINING_AVAILABILITY_CHANGES: '43e10ab61223be9b475d9316d5a36827749cd985',
  ROLLOUT_FACILITY_GUEST_LOGIN: 'eb35de36b0d30a9bc6fcded05b0ce50b860eae8e',
  ROLLOUT_IOS_FACILITY_FULLSTORY_EVENTS: '9473afffff70d2490e193cd17bc430641422a3f6',
  ROLLOUT_TRAINING_CONSULTATION_ADD_ONS: '907c53bd0c845ede15d31a65e8913b12430f5283',
  ROLLOUT_TRAINING_PAID_CONSULTATIONS: '599969e44ecc3b9ddfe2a62ef31331f15e948288',
  KILLSWITCH_ALLOW_PET_CREATION_VIA_NEW_PET_FORM: 'aef203a24520095d0a8152af14d203d7e5325c4e',
  ROLLOUT_FACILITY_VACCINE_UPLOAD_IMAGE: '64ba3deefa170f4aa8f5ce9cdd33caefe776a781',
  ROLLOUT_UNAUTHENTICATED_FACILITY_CONTACT_PAGE: 'fbcde0fa714fb60834abd73314cb8fad063a270b',
  ROLLOUT_TRAINER_PROFILE_MIXED_SERVICE_REVIEWS: 'cd79145143bcdd8935370633281d5786dda1f1ea',
  ROLLOUT_SITTER_PROMOTION_M0_OWNER: 'd2f4dbcc59e56e9bea608f5581f6554809e33b03',
  ROLLOUT_SITTER_PROMOTION_M0_LANDING_PAGE: '810eb3c9739a406f584107e6f9a28d1b6c41732a',
  ROLLOUT_TRAINING_FREE_CONSULTATIONS: '4aadcf345f5d077afe2e9d8132cda1d44d903c3b',
  ROLLOUT_PROVIDER_BUNDLE_OFFERINGS: 'b3dded3660ba9e955b6a5a7624cecca034761e6a',
  ROLLOUT_UPDATED_TRAINING_NEEDS: 'b8b54c0faef99744533329458ffa8937862a2712',
  ROLLOUT_TRAINING_SEARCH_NEEDS_FILTERS: '76a201180ba27b5fc6f8ee6f1f05eef2257ccb1a',
  ROLLOUT_SITTER_PROMOTION_M0_ENTRY_POINTS: 'd74057c86b7fe6a79e65ea4b38e1a962a65187fc',
  ROLLOUT_TRAINING_BUNDLES: '3cbc9ffa121c95d5def8362761baa1c781b6ae02',
  KILLSWITCH_FACILITY_BOOKING_ADDITIONAL_CONTACT_INFO: '28cbd88cc066c5e957be3b69c71b9ca2f2528910',
  KILLSWITCH_TRAINING_BUNDLE_CREATE_OFFERINGS: '434e52691e2a2b6da392f9533b552aa4976e1a26',
  KILLSWITCH_TRAINING_BUNDLE_VIEW_OFFERINGS: '6f77fed64e9a8d5d4753b201fc2a4f000c02064e',
  ROLLOUT_ROVER_COLLECT_VACCINATION_DOCUMENTS: '2c8a0804131ea041a2c5b4cf0ae9b4f8ba30687f',
  ROLLOUT_TRAINING_CREDENTIALS_UPLOAD: 'f610c003bf8bcb8ba8cd9d18876d9510cb6189c9',
  ROLLOUT_LEMONADE_PET_INSURANCE: 'c81af454ccc8922e749fbba81fb7ad0134de59ba',
  ROLLOUT_VIRTUAL_TRAINING_V1: '9a0d583321c7153bb2b4c86de45f9d68b57376d1',
  ROLLOUT_USER_MIGRATION_LANDING_PAGE: '74638b2580ce37d9dc4b5d67fa8476b01e053fb3',
  ROLLOUT_CALIFORNIA_TRAINING_PRICING_M1_SIGN_UP: '65c85df022603403a5f2b295fd86c76983bc17d5',
  ROLLOUT_USER_PRE_MIGRATION_LANDING_PAGE: 'a6bb5ac23d7d006f41db0e283356d2c32a42eeef',
  ROLLOUT_TRAINING_SEARCH_FAQ: '81852e2b083c8b1b5a332e5fa1a687e34d3e400c',
  ROLLOUT_TRAINING_SEARCH_CONTEXT_HEADER: '3ac435ff5b70b51247f7d5276ef912fc50c2b2d9',
  ROLLOUT_PUBLIC_TRAINER_PROFILE_SEO: '95a128a1daa479339b18dd07abb254beb3c4c268',
  ROLLOUT_TRAINING_PRICE_ANCHORING: 'd3f75ce62ca0eb456781e5f00680912f92a58639',
  ROLLOUT_TRAINING_REBOOKING_NOTIFICATIONS: 'd08c495fac518674245d8601cbf16ea1098ced83',
  KILLSWITCH_TRAINING_REBOOKING_NOTIFICATION_TASKS: '3b5f51907b1663bee05566b0b7130a666f853d0a',
  KILLSWITCH_TRAINING_SEND_REBOOKING_NOTIFICATIONS: 'df785ac0905e421afcbf22954cce5ad4109b63fa',
  KILLSWITCH_TRAINING_MOBILE_HOMEPAGE_SEARCH_INPUT: '3b5f1ca01c57eb236ea463873f12c31eda4d2c8b',
  ROLLOUT_DAILY_DASHBOARD_TRAINER_RECRUITMENT: 'a0e6c593d632e48e4c7a5111c7311d704717cb48',
  ROLLOUT_SNAPPINGCAROUSEL_V2: '0e5f67ed8de9fa98e91f850f4a6e3e9c630d140c',
  ROLLOUT_AMBASSADOR_OWNER_ENTRY_POINTS_UPLIFTS: 'ef5d56151553e1066211d3144774984d5860884a',
  ROLLOUT_DEFAULT_TO_HOME_ADDRESS: 'f3d1f4478c5dab6c4c50b83d103c26440f203b1b',
  ROLLOUT_PET_COUNTER: '9410ddeb26d8565bab64cafeef1a8f81e4848286',
  ROLLOUT_PROFILE_CTA_TO_SEARCH: '00d57ccc58a14715b899176e0834a4726fcc0f63',
  ROLLOUT_KNOWN_OWNERS_M1_EXPERIMENT: '55d6526f273c9d1c35621d21c5ddd55bf5db4ea1',
  ROLLOUT_TRAINING_CONTACT_PAGE_CONSOLIDATION_M1: 'f27827da879c20fcfdb1ef26157aaa65f3ae0f4a',
  ROLLOUT_ARTIFACTS_SHARING_SHEET_TEXT: 'a96cc2fcd9ec799ca04c963e0f6e506722082dd9',
  ROLLOUT_TRAINING_CREDENTIALS_STRUCTURED_DATA: '52cad39e0fad11148506ba93b751467bf3627a1a',
  ROLLOUT_TRAINING_SEO_LOCATION_PAGES: '8773ef06e5af1b3b8af5bcf9c72f8c9983e59877',
  ROLLOUT_COUPON_DECOUPLING: 'ff1ee8eaeecd01188f06dfd3357c902de4415b03',
  ROLLOUT_SIMPLIFIED_HOMEPAGE_HIDE_PET_SELECTOR: 'e4e21bfd2deccf02e9552715cd3dc59d281f842d',
  ROLLOUT_SIMPLIFIED_HOMEPAGE_HIDE_DATE_SCHEDULER: '40549d7a31ad2401a267fad2c4065943f2949a0d',
  ROLLOUT_SERVICE_OVERVIEW_COMPONENT: 'bcc66d980c157b5d05cc91d35b4b0fb79d2666b3',
  ROLLOUT_UPDATED_SERVICE_LANDING_PAGES: '8dd24a4249bccc0806965bb6eef492e47f44bbed',
  GINGR_FACILITY_PILOT_EXPERIMENT: '4c42bf3a1912227d765a968aa342e2309c335496',
  PET_INFO_CHIPS: 'a6cc372cdb9921568dfc48da5e2c68b800ae7ca8',
  ROLLOUT_GROOMING_SIGN_UP: '8c777254cd0ce7af8bfe4f209ed743c6c75534a8',
  ROLLOUT_REPEAT_TRAINING_CLIENT_COUNT: '902eb2b47ce5de8f70850662e4d1875727bf4d4c',
  ROLLOUT_GOODPUP_CERTIFICATION_IN_TSU: '5c645536594f94bd93053c40da6c83f10b633f44',
  ROLLOUT_SIMPLIFIED_MOBILE_SEARCH_FILTERS: '5e762efc0ad06be174792b597be89c808f5c2adf',
} as const;

/* Used in modules/Data/Core/MobileExperiment.native
     native experiments are checked by passing these values across getExperimentBucket bridge
  */
export const NATIVE_EXPERIMENTS = {
  PAYPAL_PAYINS_ANDROID: 'Paypal Payins on Android',
  PAYPAL_PAYINS_IOS: 'Paypal Payins on iOS',
  PAYMENT_SHEET_IOS: 'iOS Payment Sheet Experiment',
} as const;
